/** @format */

// src/App.js
import {useState, useEffect} from "@wordpress/element";
import AdminEntriesTable from "./components/AdminEntriesTable.js";

const App = () => {
	const [currentTab, setCurrentTab] = useState("entries");
	const [ageStandard, setAgeStandard] = useState("standard_hs"); // Enforced plugin-wide standard fallback flag
	const [systemLoading, setSystemLoading] = useState(true);

	const getGlobalRoutingData = () => {
		if (typeof window !== "undefined") {
			if (window.ammData) return window.ammData;
			if (window.wp?.ajax?.settings?.ammData) return window.wp.ajax.settings.ammData;
		}
		return null;
	};

	useEffect(() => {
		// 1. URL Router Mapping Evaluation
		const handleUrlRouting = () => {
			const params = new URLSearchParams(window.location.search);
			const activeTab = params.get("tab");
			if (activeTab === "entries" || !activeTab) {
				setCurrentTab("entries");
			}
		};

		// 2. Fetch Master Dynamic Global Settings Config Parameters
		const fetchSystemConfiguration = () => {
			const globalRouting = getGlobalRoutingData();
			if (!globalRouting?.api_url) {
				setSystemLoading(false);
				return;
			}

			fetch(`${globalRouting.api_url}/meta`, {
				headers: {"X-WP-Nonce": globalRouting.nonce},
			})
				.then((res) => {
					if (!res.ok) throw new Error("Master database config response rejected.");
					return res.json();
				})
				.then((data) => {
					if (data && data.ageStandard) {
						setAgeStandard(data.ageStandard); // Match dynamic rules context ('standard_hs' / 'standard_intl')
					}
					setSystemLoading(false);
				})
				.catch((err) => {
					console.error("Advanced MM Master Settings Load Error:", err);
					setSystemLoading(false);
				});
		};

		handleUrlRouting();
		fetchSystemConfiguration();

		window.addEventListener("popstate", handleUrlRouting);
		return () => window.removeEventListener("popstate", handleUrlRouting);
	}, []);

	return (
		<div className="wrap advanced-mm-admin-scope">
			<h1 className="wp-heading-inline">Advanced Meeting Manager</h1>
			<span className="badge text-uppercase border ms-2 p-1 font-monospace bg-white text-secondary small">v3.0.0 — {ageStandard === "standard_hs" ? "ISSA High School Standard" : "WA International Standard"}</span>
			<hr className="wp-header-end" />

			{/* Native WordPress Screen Navigation Tab Interfaces */}
			<nav className="nav-tab-wrapper wp-clearfix" style={{marginBottom: "20px"}}>
				<a
					href="?page=advanced-mm&tab=entries"
					className={`nav-tab ${currentTab === "entries" ? "nav-tab-active fw-bold" : ""}`}
					onClick={(e) => {
						if (window.history.pushState) {
							e.preventDefault();
							const newUrl = `${window.location.pathname}?page=advanced-mm&tab=entries`;
							window.history.pushState({path: newUrl}, "", newUrl);
							setCurrentTab("entries");
						}
					}}>
					<i className="dashicons dashicons-forms me-1 align-middle"></i> Verify Roster Entries
				</a>
			</nav>

			{/* Dynamic Content Body Area */}
			<div className="amm-admin-content mt-3">
				{systemLoading ? (
					<div className="notice notice-info visual-clean-spinner p-3">
						<p>
							<span className="spinner is-active ps-2"></span> Synthesizing database registration configurations...
						</p>
					</div>
				) : (
					currentTab === "entries" && <AdminEntriesTable ageStandard={ageStandard} />
				)}
			</div>
		</div>
	);
};

export default App;
